var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.5974,
    height: 79.5974,
    rx: 39.7987,
    fill: "#2A2A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0649 41.4569C53.0649 49.7483 47.261 53.894 40.3625 56.2985C40.0013 56.4209 39.6089 56.4151 39.2515 56.2819C32.3364 53.894 26.5325 49.7483 26.5325 41.4569V29.849C26.5325 29.4091 26.7072 28.9874 27.0182 28.6764C27.3292 28.3654 27.7509 28.1907 28.1908 28.1907C31.5073 28.1907 35.653 26.2007 38.5384 23.6802C38.8897 23.38 39.3366 23.2151 39.7987 23.2151C40.2608 23.2151 40.7077 23.38 41.059 23.6802C43.961 26.2173 48.0901 28.1907 51.4067 28.1907C51.8465 28.1907 52.2683 28.3654 52.5792 28.6764C52.8902 28.9874 53.0649 29.4091 53.0649 29.849V41.4569Z",
    stroke: "white",
    strokeWidth: 3.31656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService01);
export default __webpack_public_path__ + "static/media/service01.0cc82b7ffcbd2602b51a678af2d4799f.svg";
export { ForwardRef as ReactComponent };